var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
		_vm.$style['app-notched-outline'],
		{
			[_vm.$style['app-notched-outline--visible']]: _vm.isFocused,
			[_vm.$style['app-notched-outline--notched']]: _vm.isFloated
		}
	]})
}
var staticRenderFns = []

export { render, staticRenderFns }